module App

open Elmish
open Elmish.React
open ViewTypes

#if DEBUG
open Elmish.Debug
open Elmish.HMR
#endif

let render (state: State) (dispatch: Msg -> unit) =
  SiteStructuur.renderSite state dispatch

Program.mkProgram ViewTypes.init InitAndUpdate.update render
#if DEBUG
|> Program.withConsoleTrace
#endif
|> Program.withReactSynchronous "elmish-app"
#if DEBUG
|> Program.withDebugger
#endif
|> Program.run
